import React from "react";
import ConfigurableProducts from "./ConfigurableProducts";
import "./sb-theme/index.scss";
import Base from "./Base";
const ConfiguratorApp = () => {
  return (
    <Base>
      {/* <h1>Configurator App</h1> */}
      <ConfigurableProducts />
    </Base>
  );
};

export default ConfiguratorApp;
